export class RegexpSearch {
    public static Search (str1: string, str2: string): boolean {
        str1 = str1.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase() ;
        str2 = str2.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase() ;
        return str1.includes(str2) ;
    }
}
